export default "__VITE_ASSET__Dxet_gYn__"